import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import CreditCardBox from './credit_card_box';
import AdyenCreditCardForm from './adyen_credit_card_form';

class EditableCreditCard extends React.Component {
  get isPrimary() {
    return this.props.creditCard.creditCardId === this.props.primaryCardId;
  }

  handleFormUpdate() {
    if (this.isPersistedCard()) {
      this.cancelEditing();
    }
    this.props.handleUpdate();
  }

  nowEditing() {
    this.props.handleEditing(this.props.creditCard.creditCardId);
  }

  cancelEditing() {
    this.props.handleEditing(null);
  }

  isPersistedCard() {
    return this.props.creditCard.creditCardId != null;
  }

  componentToRender() {
    if (this.props.editing) {
      return (
        <AdyenCreditCardForm
          creditCard={this.props.creditCard}
          cancelEditing={() => this.cancelEditing()}
          handleUpdate={() => this.handleFormUpdate()}
          countriesForSelect={this.props.countriesForSelect}
          formObjectName={this.props.formObjectName}
        />
      );
    }

    return (
      <CreditCardBox
        creditCard={this.props.creditCard}
        nowEditing={() => this.nowEditing()}
        isPrimary={this.isPrimary}
        handleUpdate={() => this.handleFormUpdate()}
        updatePrimaryCard={cardId => this.props.updatePrimaryCard(cardId)}
      />
    );
  }

  wrappedCreditCard() {
    const classes = classNames(
      'boxed-list__item',
      { 'boxed-list__item--active': this.props.editing },
    );

    return (
      <div className={classes}>
        {this.componentToRender()}
      </div>
    );
  }

  render() {
    return (
      <li>
        {this.wrappedCreditCard()}
      </li>
    );
  }
}

EditableCreditCard.propTypes = {
  creditCard: PropTypes.shape({
    creditCardId: PropTypes.string,
    cardType: PropTypes.string,
    lastFour: PropTypes.string,
    cardholderName: PropTypes.string,
    expirationMonth: PropTypes.string,
    expirationYear: PropTypes.string,
    fullExpirationYear: PropTypes.string,
    streetAddress: PropTypes.string,
    extendedAddress: PropTypes.string,
    locality: PropTypes.string,
    region: PropTypes.string,
    postalCode: PropTypes.string,
    countryCode: PropTypes.string,
    cardSource: PropTypes.string,
  }).isRequired,
  countriesForSelect: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleUpdate: PropTypes.func.isRequired,
  primaryCardId: PropTypes.string.isRequired,
  editing: PropTypes.bool,
  formObjectName: PropTypes.string.isRequired,
  updatePrimaryCard: PropTypes.func,
  handleEditing: PropTypes.func.isRequired,
};

EditableCreditCard.defaultProps = {
  editing: null,
  updatePrimaryCard: null,
};

export default EditableCreditCard;



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/editable_credit_card.jsx